<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <div class="card">
      <div class="card-body" style="padding-top: 20px !important">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <hr class="mt-0" />
            <p style="font-size: 14px" class="mt-1">
              {{ $t("num_sms") }}
            </p>
            <form class="" @submit.prevent="submitForm">
              <!-- <div class="form-group  mt-4 col-md-5 col-12 col-sm-7" style="">
                <label>{{ $t("sms_plan") }}</label>
                <select
                  class="form-control"
                  name="sms-interval"
                  v-model="smsInterval"
                  @change="planChange"
                >
                  <option value="daily">{{ $t("daily") }}</option>
                  <option value="weekly">{{ $t("weekly") }}</option>
                  <option value="monthly">{{ $t("monthly") }}</option>
                </select>
              </div> -->

              <div class="form-group col-md-5 col-12 col-sm-7">
                <label>{{ $t("max_sms") }}</label>
                <input
                  type="number"
                  name="dailyMaximumNumberOfSms"
                  v-model.number="dailyMaximumNumberOfSms"
                  class="form-control"
                  required
                />
              </div>
              <!-- <div
                v-if="maxSmsError"
                align="center"
                class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
              >
                <p class="alert-close mb-0">
                  {{ maxSmsError }}
                </p>
              </div> -->

              <button class="btn btn-primary mt-3 ml-auto d-block">
                {{ $t("save") }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer text-center">
      &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
export default {
  name: "WalletSettings",
  components: {
    Loading,
  },
  data() {
    return {
      smsInterval: null,
      maxSms: null,
      isLoading: false,
      fullPage: true,
      maxSmsError: "",
      dailyMaximumNumberOfSms: "",
    };
  },
  methods: {
    ...mapActions(["getsmsunits", "updateSmsSettings"]),
    submitForm() {
      // if (this.maxSms === null || this.maxSms === undefined) {
      //   this.maxSmsError = this.$t("sel_max");
      //   return;
      // }
      this.isLoading = true;
      const smsSettings = {
        data: { dailyMaximumNumberOfSms: this.dailyMaximumNumberOfSms },
        id: this.smsUnits.id,
      };
      this.updateSmsSettings(smsSettings)
        .then(() => {
          this.getsmsunits().then(() => {
            this.isLoading = false;
            // this.maxSms = this.smsSettings.cap;
            // this.smsInterval = this.smsSettings.interval;
          });
          // this.isLoading = false;
          // this.mssg =
          //   res.data.message[0].toUpperCase() + res.data.message.slice(1);
          setTimeout(() => {
            this.mssg = "";
          }, 1000);
        })
        .catch((error) => {
          this.isLoading = false;
          const errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          this.updateErrMsg(errormssg).then(() => {
            setTimeout(() => {
              this.updateErrMsg("");
            }, 6000);
          });
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    planChange() {
      if (this.smsInterval !== this.smsSettings.interval) {
        this.maxSms = null;
      } else {
        this.maxSmsError = "";
        this.maxSms = this.smsSettings.cap;
      }
    },
  },
  computed: {
    ...mapGetters(["smsSettings", "smsUnits"]),
  },
  mounted() {
    // this.getSmsSettings().then(() => {
    //   this.isLoading = false;
    //   this.maxSms = this.smsSettings.cap;
    //   this.smsInterval = this.smsSettings.interval;
    // });
    this.dailyMaximumNumberOfSms =
      this.smsUnits.settings.dailyMaximumNumberOfSms;
  },
};
</script>

<style>
@media (min-width: 767px) {
  .card-body {
    padding: 2rem !important;
  }
}
</style>
<i18n>
{
	"en": {
		"daily": "Daily",
		"max_sms": "Daily Maximum Number of SMS",
		"monthly": "Monthly",
		"num_sms": " Set the number of SMS sent per day.",
		"sel_max": "Select maximum number of SMS",
		"sms_plan": "Choose SMS plan Interval",
		"weekly": "Weekly"
	},
	"es": {
		"daily": "diario",
		"max_sms": "Número máximo de SMS",
		"monthly": "Mensual",
		"num_sms": " Establezca la cantidad de SMS enviados por día.",
		"sel_max": "Seleccione el número máximo de SMS",
		"sms_plan": "Elija el intervalo del plan de SMS",
		"weekly": "Semanal"
	},
	"fr": {
		"daily": "du quotidien",
		"max_sms": "Nombre maximum de SMS",
		"monthly": "Mensuel",
		"num_sms": " Définissez le nombre de SMS envoyés par jour.",
		"sel_max": "Sélectionnez le nombre maximum de SMS",
		"sms_plan": "Choisissez le forfait SMS Intervalle",
		"weekly": "Hebdomadaire"
	},
	"sw": {
		"daily": "Kila siku",
		"max_sms": "Idadi ya juu zaidi ya SMS",
		"monthly": "kila mwezi",
		"num_sms": " Weka nambari ya SMS iliyotumwa kwa siku.",
		"sel_max": "Chagua idadi ya juu zaidi ya SMS",
		"sms_plan": "Chagua Muda wa Mpango wa SMS",
		"weekly": "Kila wiki"
	}
}
</i18n>
